import { render, staticRenderFns } from "./CreateParticipantDialog.vue?vue&type=template&id=2145e5c7&"
import script from "./CreateParticipantDialog.vue?vue&type=script&lang=js&"
export * from "./CreateParticipantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports